import { render, staticRenderFns } from "./LoadingProgress.vue?vue&type=template&id=3d70a905"
import script from "./LoadingProgress.vue?vue&type=script&lang=js"
export * from "./LoadingProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports